import { render, staticRenderFns } from "./CorrelationSection.vue?vue&type=template&id=c17f1478&scoped=true&"
import script from "./CorrelationSection.vue?vue&type=script&lang=js&"
export * from "./CorrelationSection.vue?vue&type=script&lang=js&"
import style0 from "./CorrelationSection.vue?vue&type=style&index=0&id=c17f1478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17f1478",
  null
  
)

export default component.exports